(function () {
  'use strict';

  var DRAWER_SELECTOR = '.mfp-wrap .modal-popup > .cart_menu';
  var CONTROL_SELECTOR = '.plus_btn, .minus_btn, .remove_item_button';
  var CASH_DISCOUNT_NOTICE_TEXT = 'All prices are shown in Barbados dollars (BBD) and already include the cash discount where applicable.';

  function normaliseDrawerControls(root) {
    var controls = (root || document).querySelectorAll(
      DRAWER_SELECTOR + ' .plus_btn, ' + DRAWER_SELECTOR + ' .minus_btn'
    );
    var index;

    for (index = 0; index < controls.length; index += 1) {
      controls[index].removeAttribute('href');
      controls[index].setAttribute('role', 'button');
      controls[index].setAttribute('tabindex', '0');
    }
  }

  function ensureCashDiscountNotice(root) {
    var totalRows = (root || document).querySelectorAll(
      DRAWER_SELECTOR + ' .total_row, body.template-cart #KjsCartForm .total_row'
    );
    var index;
    var totalRow;
    var notice;

    for (index = 0; index < totalRows.length; index += 1) {
      totalRow = totalRows[index];
      if (totalRow.querySelector('[data-kjs-cash-discount-notice]')) continue;

      notice = document.createElement('p');
      notice.className = 'kjs-cash-discount-notice kjs-cash-discount-notice--cart';
      notice.setAttribute('data-kjs-cash-discount-notice', '');
      notice.textContent = CASH_DISCOUNT_NOTICE_TEXT;
      totalRow.appendChild(notice);
    }
  }

  function cartRootUrl(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function showCartError(row, variantId, message) {
    var error = row && row.querySelector('.ajaxcart__item__' + variantId + '__errors');
    if (!error) return;
    error.textContent = message;
    error.style.display = 'block';
    window.setTimeout(function () { error.style.display = 'none'; }, 2500);
  }

  function updateDrawer(control) {
    var row = control.closest('.cart_row > ul');
    var input = row && row.querySelector('.number_val_input');
    var line = input ? parseInt(input.getAttribute('data-line'), 10) : 0;
    var variantId = input ? parseInt(input.getAttribute('data-id'), 10) : 0;
    var current = input ? parseInt(input.value, 10) : 0;
    var next = current;

    if (!row || !input || !line || !window.Shopify ||
        typeof window.fetch !== 'function' ||
        typeof Shopify.updateQuickCart !== 'function') {
      return;
    }

    if (row.getAttribute('data-kjs-cart-changing') === 'true') return;

    if (control.classList.contains('remove_item_button')) next = 0;
    else if (control.classList.contains('plus_btn')) next = current + 1;
    else next = Math.max(0, current - 1);

    row.setAttribute('data-kjs-cart-changing', 'true');
    control.setAttribute('aria-busy', 'true');

    window.fetch(cartRootUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: next })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart change rejected');
      return response.json();
    }).then(function (cart) {
      var matchingQuantity = 0;
      var index;

      if (control.classList.contains('plus_btn') && cart && cart.items) {
        for (index = 0; index < cart.items.length; index += 1) {
          if (Number(cart.items[index].variant_id) === variantId) {
            matchingQuantity += Number(cart.items[index].quantity) || 0;
          }
        }
        if (matchingQuantity < next) {
          row.removeAttribute('data-kjs-cart-changing');
          control.removeAttribute('aria-busy');
          showCartError(row, variantId, 'All available stock is in your cart.');
          return;
        }
      }

      Shopify.updateQuickCart(cart);
    }).catch(function () {
      row.removeAttribute('data-kjs-cart-changing');
      control.removeAttribute('aria-busy');
      showCartError(
        row,
        variantId,
        control.classList.contains('plus_btn')
          ? 'All available stock is in your cart.'
          : 'The cart could not be updated. Please try again.'
      );
    });

    window.setTimeout(function () {
      if (!row.isConnected) return;
      row.removeAttribute('data-kjs-cart-changing');
      control.removeAttribute('aria-busy');
    }, 6000);
  }

  document.addEventListener('click', function (event) {
    var control = event.target && event.target.closest ? event.target.closest(CONTROL_SELECTOR) : null;

    if (!control || !control.closest(DRAWER_SELECTOR)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    updateDrawer(control);
  }, true);

  function initialise() {
    normaliseDrawerControls(document);
    ensureCashDiscountNotice(document);
    if (typeof window.MutationObserver !== 'function') return;
    new MutationObserver(function () {
      normaliseDrawerControls(document);
      ensureCashDiscountNotice(document);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
}());

